import { Box, Text } from '@shopify/polaris';

// Paleta pastel — alineada con el PDF y con los gráficos del front (D3).
export const PIE_BLUE = '#a4c2d8'; // en campaña
export const PIE_SALMON = '#d8b4a4'; // fuera de campaña
export const PIE_GREEN = '#a4c8a8'; // restante / almacén

// Pastel inline con SVG. `slices` = [{label, value, color}].
export const Pie = ({ title, slices, formatValue }) => {
  const radius = 70;
  const size = radius * 2;
  const cx = radius;
  const cy = radius;

  const valid = slices.filter((s) => s.value > 0);
  const total = valid.reduce((acc, s) => acc + s.value, 0);

  // Genera el path SVG del sector entre dos ángulos.
  const arcPath = (a0, a1) => {
    const x0 = cx + Math.cos(a0) * radius;
    const y0 = cy + Math.sin(a0) * radius;
    const x1 = cx + Math.cos(a1) * radius;
    const y1 = cy + Math.sin(a1) * radius;
    const large = a1 - a0 > Math.PI ? 1 : 0;
    return `M ${cx} ${cy} L ${x0} ${y0} A ${radius} ${radius} 0 ${large} 1 ${x1} ${y1} Z`;
  };

  let startAngle = -Math.PI / 2;
  const paths = valid.map((s) => {
    const sweep = (s.value / total) * 2 * Math.PI;
    const endAngle = startAngle + sweep;
    const d = arcPath(startAngle, endAngle);
    startAngle = endAngle;
    return { d, color: s.color, pct: total > 0 ? s.value / total : 0 };
  });

  return (
    <Box>
      <Text variant="headingSm" as="h4">
        {title}
      </Text>
      <Box minHeight=".5rem" />
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {total > 0 ? (
          <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {paths.map((p, i) => (
              <path key={i} d={p.d} fill={p.color} stroke="#FFFFFF" strokeWidth={2} />
            ))}
          </svg>
        ) : (
          <div style={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text tone="subdued">Sin datos</Text>
          </div>
        )}
        <div style={{ flex: 1, fontSize: 13 }}>
          {slices.map((s) => {
            const pct = total > 0 && s.value > 0 ? (s.value / total) * 100 : 0;
            return (
              <div key={s.label} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8 }}>
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: s.color,
                    borderRadius: 2,
                    marginTop: 3,
                    flexShrink: 0,
                  }}
                />
                <div style={{ lineHeight: 1.3 }}>
                  <div style={{ fontWeight: 600 }}>{s.label}</div>
                  <div style={{ color: '#6B7280', fontSize: 12 }}>
                    {formatValue(s.value)}
                    {pct > 0 && <span style={{ marginLeft: 6 }}>{`(${pct.toFixed(1)}%)`}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Box>
  );
};
